import React from 'react'
import { ReactComponent as Icon } from "../../assets/svg/server-down.svg"

export default function MaintenancePage() {

    return(
        <div className="nothing-found-block unauthorized">
            <div className="content-of-nothing-found-block">

                <Icon />

                <h3>Maintenance</h3>
                <p>The application is currently unavailable.</p>

            </div>
        </div>
    )
}